import {
  ComponentInCsm,
  EditorAddonComponent,
  EditorClientSpecMapEntry,
} from '@wix/document-services-types';
import { ApplicationType } from '@wix/editor-application';
import { IAddonIApplicationSpecData, IApplicationSpec } from '../../types';
import { ApplicationSpecExtractor } from './types';

const isAddon = (
  component: ComponentInCsm,
): component is EditorAddonComponent => {
  return component.type === ApplicationType.EditorAddon;
};

export class AddonsExtractor
  implements ApplicationSpecExtractor<IAddonIApplicationSpecData>
{
  public extract(
    app: EditorClientSpecMapEntry,
  ): IApplicationSpec<IAddonIApplicationSpecData>[] {
    const appDefinitionId = app.appDefinitionId;
    if (!app.components || !appDefinitionId) {
      return [];
    }

    const addons: IApplicationSpec<IAddonIApplicationSpecData>[] = [];

    const components = app.components;

    for (const component of components) {
      if (!isAddon(component)) {
        continue;
      }

      const { editorScript, toolPanelConfig, marketData } =
        component.data || {};

      const addon: IApplicationSpec<IAddonIApplicationSpecData> = {
        appDefinitionId,
        appDefinitionName: app.appDefinitionName || 'Unknown addon',
        type: ApplicationType.EditorAddon,
        data: {
          toolPanelConfig: {
            ...(toolPanelConfig || {}),
            initialPosition: {
              x: '200',
              y: '200',
              ...toolPanelConfig?.initialPosition,
            },
          },
          marketData,
        },
      };

      if (editorScript) {
        addon.url = editorScript;
      }

      addons.push(addon);
    }

    return addons;
  }
}
